/**
 * Whether this browser has already sent the post-check, so the "the post-check is open" banner on every page stops once it is done.
 * A send is remembered in this browser, so the banner may show again on another device until the person opens the check, which then shows it is done.
 */
const key = (cohortId: string): string => `bsim.postCheckSent.${cohortId}`;

export const postCheckSent = (cohortId: string): boolean => {
  try { return globalThis.localStorage?.getItem(key(cohortId)) === "1"; } catch { return false; }
};

export const rememberPostCheckSent = (cohortId: string): void => {
  try { globalThis.localStorage?.setItem(key(cohortId), "1"); } catch { /* the banner just stays until the check is opened */ }
};

/** The line a person who puts the pre-check off reads, on the check's start screen and as a banner on every page until it is taken or the post-check opens. True whatever the round is doing. */
export const PRE_CHECK_LATER_LINE = "Your pre-check waits until this round ends; your facilitator can call you to it.";

const laterKey = (cohortId: string): string => `bsim.preCheckLater.${cohortId}`;
export const preCheckLater = (cohortId: string): boolean => {
  try { return globalThis.localStorage?.getItem(laterKey(cohortId)) === "1"; } catch { return false; }
};
export const rememberPreCheckLater = (cohortId: string): void => {
  try { globalThis.localStorage?.setItem(laterKey(cohortId), "1"); } catch { /* the banner only shows in this browser */ }
};
export const forgetPreCheckLater = (cohortId: string): void => {
  try { globalThis.localStorage?.removeItem(laterKey(cohortId)); } catch { /* nothing kept */ }
};
